import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Play = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Play' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='3 22 21 12 3 2' />
  </StyledIcon>
);
